module.exports = __webpack_public_path__ + "static/Fence-43bb3378c394edf196fc3fc4388e6446.jpg";